export const TEXT_ALIGN_VALUES = ['left', 'center', 'right', 'justify'] as const;

/**
 * Content column width an email is built at, in px. The theme wraps its
 * container table at this width, so it is the width the editor canvas mirrors
 * (see DocumentDesign.width) — one number, read by the build and the canvas,
 * instead of the literal repeated in each.
 */
export const EMAIL_CONTENT_WIDTH = 500;
export const TEXT_TRANSFORM_VALUES = [
  'uppercase',
  'capitalize',
  'lowercase',
  'none',
  'inherit',
  'initial',
  'revert',
  'revert-layer',
  'unset',
] as const;
export const OBJECT_FIT_VALUES = ['cover', 'contain', 'fill', 'scale-down', 'none'] as const;
export const FLEX_DIRECTION_VALUES = ['row', 'column'] as const;
export const FONT_STYLE_VALUES = ['normal', 'italic'] as const;

export const SIGNATURE_LAYOUT_VALUES = ['left', 'center'] as const;
export const SIGNATURE_VARIANT_VALUES = ['compact', 'card'] as const;
export const SECTION_VERTICAL_ALIGN_VALUES = ['start', 'center', 'end'] as const;

export const SECTION_BG_SIZE_VALUES = ['cover', 'contain', 'auto'] as const;
export const SECTION_BG_TYPE_VALUES = ['color', 'image', 'gradient', 'video'] as const;

export const BUTTON_VARIANT_TYPES = ['primary', 'secondary', 'outline', 'link'] as const;
export const BUTTON_TARGET_TYPES = ['_self', '_blank'] as const;

export const COLUMN_VERTICAL_ALIGN_VALUES = ['top', 'middle', 'bottom'] as const;

export const LIST_DIVIDER_TYPE_VALUES = ['none', 'line'] as const;

export const CALLOUT_VARIANT_VALUES = ['info', 'warning', 'success', 'danger'] as const;

export const EMBED_PROVIDER_VALUES = ['youtube', 'twitter', 'generic'] as const;

export const STEPS_LAYOUT_VALUES = ['vertical', 'horizontal', 'alternating'] as const;
export const STEPS_CONNECTOR_TYPE_VALUES = ['line', 'arrow', 'dashed'] as const;
export const STEPS_STEP_SIZE_VALUES = ['sm', 'md', 'lg'] as const;

export const STAT_LAYOUT_VALUES = ['row', 'grid'] as const;

export const TABLE_CAPTION_POSITION_VALUES = ['top', 'bottom'] as const;
export const TABLE_DENSITY_VALUES = ['compact', 'normal', 'roomy'] as const;
export const TABLE_VERTICAL_ALIGN_VALUES = ['top', 'middle', 'bottom'] as const;

export const OVERFLOW_VALUES = ['hidden', 'visible'] as const;
